import { Component } from '@angular/core';
import { SharedService, GameType, ConfigService, LotteryResultRequest, LotteryBetSlip, LotteryService } from 'baseline-lib';
import { ToastController, NavController, LoadingController } from 'ionic-angular';
import { DatePipe } from '@angular/common';
import { ResultDetailPage } from '../result-detail/result-detail';
import { CustomToast } from '../../shared/services/custom-toast';
import { Global } from '../../../global/global';
import { LotteryResultService } from 'baseline-lib';


/**
 * Generated class for the ResultComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'result',
  templateUrl: 'result.html'
})
export class ResultComponent {

  fromDate: any;
  toDate: any;
  _gameTypeList: any[] = [];
  _gameList: any[] = [];
  _drawResultList: any = [];
  _selectedGameId: number;
  _serverError: any;
  isError: boolean;
  _showMNO: boolean = false;
  gameName : any;
  fromdate : any;
  todate : any;
  gameSubType : any;
  loader : any;
  subscribeObject : any;
  showtoggle:boolean=false;

  constructor(public navCtrl: NavController, public _sharedServices:SharedService,
    public _configService:ConfigService,public _lotteryService:LotteryService,
    public toast: CustomToast,public datepipe: DatePipe,
    public loadingCtrl : LoadingController,public globalData: Global,public _lotteryResultService: LotteryResultService,) {
      
    console.log('Hello ResultComponent Component');    
  }

  ngOnInit()
  {
    this._lotteryResultService.isError = false;
    this._lotteryResultService._gameTypeList = [];
    this._lotteryResultService._gameList = [];
    // var DateObj = new Date();

    this._lotteryResultService.getGameType();
    this._lotteryResultService._fromDate =  this._lotteryResultService._toDate = {
      date: {
        year: this._sharedServices.getServerTime().getFullYear(),
        month: this._sharedServices.getServerTime().getMonth() + 1,
        day: this._sharedServices.getServerTime().getDate()
      },
      jsdate: new Date()
  };

  this.fromdate = this._sharedServices.getServerTime().toISOString();
  this.todate = this._sharedServices.getServerTime().toISOString();
  if(this._lotteryResultService._gameTypeList && this._lotteryResultService._gameTypeList.length > 0){
    this.gameSubType = this._lotteryResultService._gameTypeList[0];
  }

  // if(!this._lotteryResultService.drawResultLoader.isStopped){
  //   this._lotteryResultService.drawResultLoader.unsubscribe();
  // }
  this.subscribeObject = this._lotteryResultService.drawResultLoader.subscribe(value =>{
    if(value!= null){
      if(value){ //show loader
         this.loader = this.loadingCtrl.create({
          content: "Please Wait",
        });
        this.loader.present();
      
      }else{
        if(this.loader){
          this.loader.dismiss();
        }
        if(!this._lotteryResultService.isError){
          if(this._lotteryResultService._gameTypeList && this._lotteryResultService._gameTypeList.length > 0){
            this.navCtrl.push(ResultDetailPage);
          }
        }
      }
    }
  });
}


  onGameTypeClick() {
    this.showtoggle=false
    this._lotteryResultService.getGames(this.gameSubType);
  }

  onGameClick() {
    this._lotteryResultService._selectedGameId = this.gameName;
    if(this._lotteryResultService._selectedGameId){
      this.showtoggle=true;
    }
    this._lotteryResultService._drawResultList = [];
  }

  validateDate(): boolean {
    this._drawResultList = [];
    this._serverError = '';
    if (!this.fromDate || !this.toDate) {
      this._serverError = "Please select date.";
      this.isError = true;
      this.toast.showError(this._serverError);
      return false
    }
    if (this.fromDate > this.toDate) {
      this._serverError = "To date should be greater than from date.";
      this.isError = true;
      this.toast.showError(this._serverError);
      return false
    }
    return true;
  }

  getDrawResult() {
    var fdate  = new Date(this.fromdate);

      this._lotteryResultService._fromDate = {
      date: {
        year: fdate.getFullYear(),
        month: fdate.getMonth() + 1,
        day: fdate.getDate()
       },
         jsdate: new Date(this.fromdate)
      };

    var tdate  = new Date(this.todate);

    this._lotteryResultService._toDate = {
    date: {
      year: tdate.getFullYear(),
      month: tdate.getMonth() + 1,
      day: tdate.getDate()
      },
         jsdate: new Date(this.todate)
      };

    console.log("jsdate", this._lotteryResultService._fromDate.jsdate);
    this._lotteryResultService.getDrawResult();

    // if(this._lotteryResultService._drawResultList.length > 0){
      this._drawResultList = [];
      this._serverError = '';
      this.isError = false;              
      this._drawResultList = this._lotteryResultService._drawResultList;
  }

  ngOnDestroy(){
    if(!this.subscribeObject.isStopped){
      this.subscribeObject.unsubscribe();
    }
   
  }
}



// WEBPACK FOOTER //
// ./src/app/result/result/result.ts